/**
 * What only the browser knows about the visitor's setup — sent with page views
 * (`AnalyticsService`) and with every support request and ticket
 * (`RequestService.submit`), with no input from the visitor.
 *
 * The IP address, user agent (browser / OS / device) and Accept-Language are
 * deliberately **not** here: the API takes them from the request itself, so
 * they cannot be forged from the browser. Lengths match the API's caps.
 */
export interface ClientContext {
  /** Where the visitor came from; '' for a direct visit. */
  referrer: string;
  /** navigator.language, e.g. "nl-NL". */
  language: string;
  /** The screen (not the window), e.g. "390x844". */
  screen: string;
  /** IANA time zone, e.g. "Europe/Amsterdam". */
  timezone: string;
}

export function clientContext(
  doc: Document,
  referrer = doc.referrer,
): ClientContext {
  const win = doc.defaultView;
  let timezone = '';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    // Very old engines: no zone is better than no request.
  }
  return {
    referrer: (referrer ?? '').slice(0, 2048),
    language: (win?.navigator.language ?? '').slice(0, 35),
    screen: win ? `${win.screen.width}x${win.screen.height}`.slice(0, 20) : '',
    timezone: timezone.slice(0, 64),
  };
}
